import type { UploadFile, UploadSubscriber, VideoType } from 'lib/media-upload-file';
import { useEffect } from 'react';
import type { FormInstance } from 'ui';

type P = {
  file?: UploadFile;
  form: FormInstance;
  formName: string;
  type: VideoType;
};

export const useFormFileSubscribe = ({ file, form, formName, type }: P) => {
  useEffect(() => {
    if (!file) {
      return;
    }

    const updateFormField = ({ percent, status }: { percent?: number; status: 'done' | 'error' | 'uploading' }) => {
      form.setFieldsValue({
        [formName]: [
          {
            name: file.file.name,
            percent,
            status,
            uid: type,
          },
        ],
      });
    };

    const subscriber: UploadSubscriber = {
      onAbort() {
        form.setFieldsValue({ [formName]: undefined });
      },
      onError() {
        updateFormField({ status: 'error' });
      },
      onProgress({ percent }) {
        updateFormField({ percent, status: 'uploading' });
      },
      onSuccess() {
        updateFormField({ status: 'done' });
      },
    };

    file.subscribe(subscriber);

    return () => {
      file.unsubscribe(subscriber);
    };
  }, [file, form, formName, type]);
};
